import React, { useContext, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import Input from '../../components/UI/Input';
import Button from '../../components/UI/Button';
import OAuthButtons from '../../components/Auth/OAuthButtons';
import { AuthContext } from '../../context/AuthContext';

export default function Login() {
	const { login } = useContext(AuthContext);
	const navigate = useNavigate();
	const location = useLocation();
	const [form, setForm] = useState({ email: '', password: '', remember: true });
	const [loading, setLoading] = useState(false);

	function onChange(e) {
		const { name, type, checked, value } = e.target;
		setForm((f) => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
	}

	async function onSubmit(e) {
		e.preventDefault();
		if (!form.email || !form.password) {
			toast.error('Please enter email and password');
			return;
		}
		setLoading(true);
		try {
			const ok = await login(form.email, form.password);
			if (ok) {
				const dest = location.state?.from?.pathname || '/dashboard';
				navigate(dest, { replace: true });
			}
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
			<div className="w-full max-w-md bg-white shadow rounded-lg p-6">
				<h1 className="text-2xl font-bold text-center">Welcome back</h1>
				
				{/* OAuth Buttons */}
				<div className="mt-6">
					<OAuthButtons />
				</div>

				{/* Divider */}
				<div className="relative my-6">
					<div className="absolute inset-0 flex items-center">
						<div className="w-full border-t border-gray-300"></div>
					</div>
					<div className="relative flex justify-center text-sm">
						<span className="px-2 bg-white text-gray-500">Or continue with email</span>
					</div>
				</div>

				{/* Email/Password Form */}
				<form className="space-y-4" onSubmit={onSubmit}>
					<Input name="email" label="Email" value={form.email} onChange={onChange} required />
					<Input name="password" type="password" label="Password" value={form.password} onChange={onChange} required />
					<div className="flex items-center justify-between">
						<label className="flex items-center gap-2 text-sm">
							<input type="checkbox" name="remember" checked={form.remember} onChange={onChange} />
							Remember me
						</label>
						<Link to="/forgot-password" className="text-sm text-primary-600 hover:underline">
							Forgot password?
						</Link>
					</div>
					<Button type="submit" loading={loading} className="w-full">
						Login
					</Button>
				</form>
				<p className="mt-4 text-sm text-center">
					Don't have an account?{' '}
					<Link to="/register" className="text-primary-600 hover:underline">
						Register
					</Link>
				</p>
			</div>
		</div>
	);
}


